import React, { useState, useEffect, useRef } from 'react';
import {
  TextField,
  Stack,
  Box,
  Button,
  Typography,
  MenuItem,
} from '@mui/material';
import AdvancedFiltersContainer from '../../../common/AdvancedFiltersContainer';

import ServiceConfigFormattedMessages from '../../../../messages/admin/ServiceConfigFormattedMessages';

const Search = ({ onSearch, options }) => {
  const [searchParams, setSearchParams] = useState({
    routeStatus: '',
    routeType: '',
    routeId: '',
    routeName: '',
  });
  const [reset, setReset] = useState(false);
  // Add debounce timer ref
  const debounceTimer = useRef(null);

  useEffect(() => {
    onSearch(searchParams);
  }, [reset]);

  const clearFilters = () => {
    setSearchParams({
      routeStatus: '',
      routeType: '',
      routeId: '',
      routeName: '',
    });
    setReset(!reset);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setSearchParams((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear any existing timer
    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    // Set new timer to trigger search after 500ms
    debounceTimer.current = setTimeout(() => {
      setReset(!reset);
    }, 500);
  };

  return (
    <>
      <AdvancedFiltersContainer>
        <Box
          sx={{
            maxWidth: { lg: 674 },
          }}
        >
          <form id="filter-form">
            <Stack
              sx={{
                flexDirection: { lg: 'row' },
                gap: 2,
                marginY: 2,
              }}
            >
              <Stack>
                <Typography sx={{ whiteSpace: 'nowrap', marginTop: 1 }}>
                  By Field:
                </Typography>
              </Stack>

              <Stack sx={{ gap: 1, flex: 1 }}>
                <Stack
                  sx={{
                    flexDirection: { lg: 'row' },
                    gap: 2,
                    alignItems: { lg: 'center' },
                  }}
                >
                  <TextField
                    select
                    label={ServiceConfigFormattedMessages.status}
                    id="routeStatus"
                    value={searchParams.routeStatus}
                    onChange={handleInputChange}
                    name="routeStatus"
                    fullWidth
                    size="small"
                  >
                    <MenuItem value="">
                      <em>{ServiceConfigFormattedMessages.status}</em>
                    </MenuItem>
                    {options?.ROUTE_STATUS &&
                      Object.keys(options.ROUTE_STATUS).map((key) => (
                        <MenuItem key={key} value={key}>
                          {options.ROUTE_STATUS[key]}
                        </MenuItem>
                      ))}
                  </TextField>

                  <TextField
                    select
                    label={ServiceConfigFormattedMessages.type}
                    id="routeType"
                    value={searchParams.routeType}
                    fullWidth
                    onChange={handleInputChange}
                    name="routeType"
                    size="small"
                  >
                    <MenuItem value="">
                      <em>{ServiceConfigFormattedMessages.type}</em>
                    </MenuItem>
                    {options?.ROUTE_TYPE &&
                      Object.keys(options.ROUTE_TYPE).map((key) => (
                        <MenuItem key={key} value={key}>
                          {options.ROUTE_TYPE[key]}
                        </MenuItem>
                      ))}
                  </TextField>
                </Stack>
                <Stack
                  sx={{
                    flexDirection: { lg: 'row' },
                    gap: 2,
                  }}
                >
                  <TextField
                    id="routeId"
                    label={ServiceConfigFormattedMessages.routeId}
                    type="text"
                    fullWidth
                    value={searchParams.routeId}
                    onChange={handleInputChange}
                    name="routeId"
                    size="small"
                  />

                  <TextField
                    id="routeName"
                    label={ServiceConfigFormattedMessages.routeName}
                    type="text"
                    fullWidth
                    value={searchParams.routeName}
                    onChange={handleInputChange}
                    name="routeName"
                    size="small"
                  />
                </Stack>
              </Stack>
            </Stack>
          </form>
        </Box>
      </AdvancedFiltersContainer>

      <Stack
        sx={{
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 2,
          maxWidth: { lg: 674 },
        }}
      >
        {(searchParams.routeStatus.length > 0 ||
          searchParams.routeType.length > 0 ||
          searchParams.routeId.length > 0 ||
          searchParams.routeName.length > 0) && (
          <Button
            color="secondary"
            onClick={clearFilters}
            sx={{
              textTransform: 'none',
              textDecoration: 'underline',
              fontWeight: 400,
            }}
          >
            {ServiceConfigFormattedMessages.clear}
          </Button>
        )}
      </Stack>
    </>
  );
};

export default Search;
